export const ToastCustomOptions: any = {
  // animate :'flyRight', // you can pass any options to override defaults
  autoDismiss: 'auto',
  timeOut: 6000,
  closeButton: true,
};
